import * as React from 'react';

import { cva } from 'class-variance-authority';
import type { VariantProps } from 'class-variance-authority';

import { cn } from '@kit/ui/utils';

const buttonVariants = cva(
  'inline-flex items-center justify-center transition-colors focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50 shadow-1',
  {
    variants: {
      variant: {
        default:
          'text-content-secondary-inverted bg-action-primary hover:bg-action-primary-hover active:bg-action-primary-active',
        destructive:
          'text-content-secondary-inverted bg-action-destructive hover:bg-action-destructive-hover active:bg-action-destructive-active',
        outline:
          'text-content-secondary bg-action-outline-bg border border-action-outline hover:border-action-outline-hover active:border-action-outline-active',
        ghost:
          'text-content-secondary bg-none hover:bg-action-ghost-hover active:bg-action-ghost-active !shadow-none',
      },
      size: {
        default: 'h-9 w-9 rounded-xl p-[9px]',
        lg: 'h-10 w-10 rounded-xl p-[11px]',
        sm: 'h-8 w-8 rounded-[10px] p-2',
        xs: 'h-6 w-6 rounded p-1',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);

interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  Icon: ({ ...props }) => React.ReactElement;
}

export const IconButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, Icon, ...props }, ref) => {
    return (
      <button
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      >
        <Icon className="h-full w-full" />
      </button>
    );
  },
);
IconButton.displayName = 'Button';
